/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'

class Social extends Component {
    render () {
        return(
            <div className="social">
                <a href="https://github.com/6135512039" target="_blank" rel="noopender noreferrer"><i className="fab fa-github"></i></a>
                <a href="https://www.linkedin.com/in/kongkom-sumlee-21a19723a/" target="_blank" rel="noopender noreferrer"><i class="fab fa-linkedin"></i></a>
                <a href="https://www.facebook.com/MisterXtang" target="_blank" rel="noopender noreferrer"><i className="fab fa-facebook"></i></a>
            </div>
        );
    }
}

export default Social;